import getCurrentBreak from '@sdk/automatedBreaks/helpers/getCurrentBreak';
import getBreaksSummary from '@sdk/automatedBreaks/helpers/getBreaksSummary';
import { canEndAutomatedBreak } from '@sdk/automatedBreaks/utils';
import { TimesheetEntry } from '@sdk/timesheets/types/TimesheetEntry';

type Props = {
  automatedBreaksFeatureFlag: boolean;
  automatedBreaksEnabled: boolean;
  shift: {
    timesheetEntries: TimesheetEntry[];
    dtstart: Date;
    dtend: Date;
  };
};

const canEndBreak = ({ automatedBreaksFeatureFlag, automatedBreaksEnabled, shift }: Props) => {
  // Ending break is only prevented in automated break feature
  if (!automatedBreaksFeatureFlag || !automatedBreaksEnabled) {
    return true;
  }

  const { timesheetEntries, dtstart, dtend } = shift;
  const { breakRecords } = getBreaksSummary(timesheetEntries, dtstart, dtend);
  const currentBreak = getCurrentBreak(breakRecords);
  return canEndAutomatedBreak(currentBreak);
};

export default canEndBreak;
